export default "__VITE_ASSET__Bd_Ee$ce__"